import XEROModal from './XEROModal'

export default XEROModal